import { createContext, useState } from 'react';
import { getGithubCredentialStatus } from '@config/getGithubApis';

const clearCookie = (name: string, path: string = '/') => {
    document.cookie = `${name}=; Path=${path}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

const useValue = () => {
    let defaultUser: any = {};
    const isUserLoggedIn = localStorage.getItem('isUserLoggedIn');
    if (isUserLoggedIn) {
        const userStr = localStorage.getItem('ads.loggedInUser');
        if (userStr) {
            try {
                defaultUser = JSON.parse(userStr);
            } catch (e) {
                console.warn('Failed to parse stored user data, clearing invalid data', e);
                localStorage.removeItem('isUserLoggedIn');
                localStorage.removeItem('ads.loggedInUser');
            }
        }
    }

    const [user, setUser] = useState<any>(defaultUser);
    const [userGivenName, setUserGivenName] = useState(defaultUser.given_name || '');
    const [userLastName, setUserLastName] = useState(defaultUser.family_name || '');
    const [userEmail, setUserEmail] = useState(defaultUser.email || '');

    const [githubConnected, setGithubConnected] = useState(false);
    const [githubLogin, setGithubLogin] = useState('');
    const [githubLastAuthFailureAt, setGithubLastAuthFailureAt] = useState<string | null>(null);

    const refreshGithubCredentialStatus = async () => {
        try {
            const response = await getGithubCredentialStatus();
            if (response && response.code === 1 && response.resultObject) {
                const status = response.resultObject;
                setGithubConnected(status.connected ?? false);
                setGithubLogin(status.login ?? '');
                setGithubLastAuthFailureAt(status.lastAuthFailureAt ?? null);
            }
        } catch (error: any) {
            // Tolerate 401 silently — user not logged in yet
            if (error?.response?.status !== 401) {
                console.error('Error refreshing GitHub credential status', error);
            }
        }
    };

    const clearUser = () => {
        localStorage.removeItem('isUserLoggedIn');
        localStorage.removeItem('idToken');
        localStorage.removeItem('ads.loggedInUser');

        sessionStorage.removeItem('ads.loggedInUser');

        clearCookie('XSRF-TOKEN');

        setUserGivenName('');
        setUserLastName('');
        setUserEmail('');
        setUser({} as any);
    };

    return {
        userGivenName,
        userLastName,
        userEmail,
        user,
        githubConnected,
        githubLogin,
        githubLastAuthFailureAt,
        setUserGivenName,
        setUserLastName,
        setUserEmail,
        setUser,
        clearUser,
        setGithubConnected,
        setGithubLogin,
        setGithubLastAuthFailureAt,
        refreshGithubCredentialStatus,
    };
};

const UserContext = createContext({} as ReturnType<typeof useValue>);

const UserProvider = ({ children }: any) => {
    return <UserContext.Provider value={useValue()}>{children}</UserContext.Provider>;
};

export { UserProvider, UserContext };
